import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['sail', 0.22],
        ['tower', 0.78],
      ],
      d: 'M-2,-8h1v1h-1zM-0.5,-7.5h0.5v0.5h-0.5zM-2,-7h2v0.5h-2zM-2,-6.5h0.5v2h-0.5zM-0.5,-6.5h0.5v0.5h-0.5zM-2,-4.5h1v0.5h-1zM-2,-4h2v1.5h-2zM-1.5,-2.5h1.5v0.5h-1.5zM-2,-2h1v2h-1zM-1,0h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.24],
        ['tower', 0.76],
      ],
      d: 'M1.5,-8h0.5v1h-0.5zM0.5,-7.5h0.5v0.5h-0.5zM0.5,-7h1.5v3h-1.5zM-1,-6.5h0.5v0.5h-0.5zM-1.5,-6h0.5v1.5h-0.5zM-0.5,-5.5h0.5v1h-0.5zM0.5,-4h0.5v1h-0.5zM1.5,-4h0.5v1h-0.5zM0.5,-3h1.5v0.5h-1.5zM0.5,-2.5h1v0.5h-1zM-0.5,-2h0.5v0.5h-0.5zM1,-2h1v0.5h-1zM0.5,-1.5h1.5v1.5h-1.5zM-0.5,0h0.5v0.5h-0.5zM0.5,0h1v0.5h-1z',
    },
    {
      paint: [
        ['castleRoof', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-0.5,-11.5h0.5v0.5h-0.5zM-1,-11h1v0.5h-1zM-1.5,-10.5h1.5v1h-1.5zM-2,-9.5h2v0.5h-2zM-2.5,-9h2.5v0.5h-2.5zM-2.5,-8.5h3v0.5h-3zM-1,-8h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['castleRoof', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M0,-11h0.5v0.5h-0.5zM0,-10.5h1v0.5h-1zM0,-10h1.5v0.5h-1.5zM0,-9.5h2v0.5h-2zM0,-9h2.5v0.5h-2.5zM0.5,-8.5h2v0.5h-2zM0.5,-8h1v0.5h-1z',
    },
    {
      paint: 'tower',
      d: 'M-2.5,-8h0.5v0.5h-0.5zM2,-8h0.5v0.5h-0.5zM-1,-7.5h0.5v0.5h-0.5zM0,-7.5h0.5v1.5h-0.5zM1,-7.5h0.5v0.5h-0.5zM-1.5,-6.5h0.5v0.5h-0.5zM-0.5,-6h1v0.5h-1zM0,-5.5h0.5v1h-0.5zM-1,-4.5h1.5v0.5h-1.5zM0,-4h0.5v2h-0.5zM-2,-2.5h0.5v0.5h-0.5zM1.5,-2.5h0.5v0.5h-0.5zM0,-2h1v0.5h-1zM0,-1.5h0.5v2h-0.5z',
    },
    {
      paint: 'shadow',
      d: 'M-1,-6h0.5v1.5h-0.5zM1,-4h0.5v1h-0.5zM-1,-2h0.5v0.5h-0.5zM-1,-1.5h1v1.5h-1z',
    },
  ],
  pixels: 178,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
